import { render } from "./OtpVerify.vue?vue&type=template&id=b01e4a1a&scoped=true"
import script from "./OtpVerify.vue?vue&type=script&lang=js"
export * from "./OtpVerify.vue?vue&type=script&lang=js"

import "./OtpVerify.vue?vue&type=style&index=0&id=b01e4a1a&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b01e4a1a"]])

export default __exports__